import Vue from 'vue';
var AlertTypes;
(function (AlertTypes) {
    AlertTypes["warning"] = "warning";
    AlertTypes["error"] = "error";
})(AlertTypes || (AlertTypes = {}));
export default Vue.extend({
    name: 'serverErrors',
    props: {
        items: {
            type: Array,
            required: true
        },
        blockTitle: {
            type: String,
            required: true
        },
        alertType: {
            type: String,
            default: 'error'
        }
    },
    computed: {
        typeClass() {
            const vm = this;
            return 'serverErrors--' + vm.alertType;
        },
        getCurrentIcon() {
            const vm = this;
            switch (vm.alertType) {
                case (AlertTypes.warning): return '';
                case (AlertTypes.error): return '';
                default: return '';
            }
        },
        getCurrentColor() {
            const vm = this;
            switch (vm.alertType) {
                case (AlertTypes.warning): return vm.getColor('ACCENT.YELLOW');
                case (AlertTypes.error): return vm.getColor('ACCENT.RED_LIGHT');
                default: return '';
            }
        }
    }
});
